module.exports = __webpack_public_path__ + "media/images/thumb--secondary-8241619db8e6c67b54510d18bf74e944.jpg";